import React, { useState } from "react";
import { Box, Button, Container, Divider, Text, Icon, Flex, useDisclosure } from "@chakra-ui/react";
import { WarningIcon } from '@chakra-ui/icons';
import { HiLocationMarker } from "react-icons/hi";

import { FullForecastModal } from "./FullForecastModal";
import { formatDate, getRegionName } from "../../utils/helpers";

export const Alert = (props) => {
    const { alert, regionData, forecasts } = props;
    const [zoneForecasts, setZoneForecasts] = useState([])

    const {
        isOpen: fullForecastModalIsOpen,
        onOpen: onOpenFullForecastModal,
        onClose: onCloseFullForecastModal
    } = useDisclosure();

    const onClickForecast = (region) => {
        const forecastZones = regionData?.find((r) => r?.id === region)?.forecastZones;

        setZoneForecasts(
            forecasts?.filter((f) => forecastZones.includes(f?.data?.zone)).map((f) => f?.data)
        );

        onOpenFullForecastModal();
    }

    return (
        <Container key={alert.alertText} mb={3} textAlign="left">
            <Flex alignItems="center" pt={3} pb={2}>
                <WarningIcon color="red.500" boxSize={5} />
                <Text color="gray.700" fontSize={18} fontWeight={700} ml={3} textTransform="uppercase">
                    {alert.alertText}
                </Text>
            </Flex>
                {alert.regions.length > 0 && alert.regions.map((alertRegion) => (
                    <Box key={alertRegion.region}>
                        <Divider mb={2} />
                        <Box px={2} py={2}>
                            <Text color="gray.700" fontSize="lg" fontWeight="bold" mb={1}>
                                {getRegionName(alertRegion.region, regionData)}
                            </Text>
                            <Text fontSize="sm" color="gray.500" mb={2}>
                                Updated
                                {' '}
                                {formatDate(alert.issuanceTime)}
                            </Text>
                            <Button
                                onClick={() => onClickForecast(alertRegion.region)}
                                color='teal.500'
                                bg='transparent'
                                borderColor='teal.500'
                                borderWidth={1}
                                size='xs'
                                height={7}
                                mb={3}
                                _hover={{
                                    bg: 'teal.500',
                                    color: 'white'
                                }}
                            >
                                View Full Forecast
                            </Button>
                            {alertRegion?.zones?.length > 0 && alertRegion.zones.map((alertZone, index) => (
                                <Box key={index} py={2}>
                                    <Flex>
                                        <Icon as={HiLocationMarker} color="gray.400" boxSize={5} />
                                        <Box ml={2}>
                                            <Text color="gray.700" fontSize={16} fontWeight={600}>
                                                {alertZone.zone}
                                            </Text>
                                            <Text color="gray.600" fontSize={14}>
                                                {alertZone.timeframe}
                                            </Text>
                                        </Box>
                                    </Flex>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                ))}
            <FullForecastModal
                isOpen={fullForecastModalIsOpen}
                onClose={onCloseFullForecastModal}
                zoneForecasts={zoneForecasts}
            />
        </Container>
    );
};
